import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import ClientSwitcher from '../ClientSwitcher';

function Header() {
  const { profile, signOut } = useAuth();

  const handleSignOut = async () => {
    try {
      await signOut();
    } catch (err) {
      console.error('Erro ao sair:', err);
    }
  };

  return (
    <header className="header">
      <div className="header-left">
        <Link to="/" className="header-brand">
          SOEVAN<span className="header-brand-dot">.</span>agency
        </Link>
        <nav className="header-nav">
          <NavLink to="/" end className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
            Overview
          </NavLink>
          {profile?.role !== 'cliente' && (
            <NavLink to="/agents" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
              Agentes
            </NavLink>
          )}
          <NavLink to="/calendar" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
            Calendario
          </NavLink>
          {profile?.role !== 'cliente' && (
            <NavLink to="/chat" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
              Chat
            </NavLink>
          )}
          {profile?.role === 'admin' && (
            <NavLink to="/admin/users" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
              Admin
            </NavLink>
          )}
        </nav>
      </div>
      <div className="user-header-actions">
        <ClientSwitcher />
        {profile && (
          <div className="header-user-info">
            <div>
              <div className="header-user-name">{profile.full_name || profile.email}</div>
              <div className="header-user-role">{profile.role}</div>
            </div>
            <button className="btn-logout" onClick={handleSignOut}>Sair</button>
          </div>
        )}
      </div>
    </header>
  );
}

export default Header;
